import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useState } from 'react';
import TagAndArchiveContent from '@/components/blog/TagAndArchiveContent';
import { PAGES } from '@/constants/pages';
import { useAppSelector } from '@/redux';
import { useServices } from '@/services/useServices';
import { updateUrlWithParams } from '@/utils/blogUtils';

export const ArchiveBlogPage = ({ slug, articlesResult, title }) => {
	const currentPageUrl = `${PAGES.BLOG_ARCHIVES}/${slug}`;
	const { seoService } = useServices();
	const { storeId } = useAppSelector(({ root }) => root.storeConf);
	const router = useRouter();

	const [articlesList, setArticlesList] = useState(articlesResult);
	const [scrollTo, setScrollTo] = useState(false);

	const filterByPage = async (page) => {
		const queryParam = slug;
		const filteredArticlesList = await seoService.getFilteredArchiveBlogData(storeId, queryParam, page);

		setArticlesList(filteredArticlesList);
		setScrollTo(true);
		updateUrlWithParams({ router, currentPageUrl, page });
	};

	return (
		<TagAndArchiveContent
			title={title}
			articlesList={articlesList}
			paginationCateg={{ urlKeyword: slug }}
			filterArticlesList={filterByPage}
			scrollTo={scrollTo}
		/>
	);
};

ArchiveBlogPage.propTypes = {
	articlesResult: PropTypes.shape({
		content: PropTypes.array.isRequired,
		pageable: PropTypes.object.isRequired,
		totalElements: PropTypes.number.isRequired,
		totalPages: PropTypes.number.isRequired,
	}).isRequired,
	slug: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
};

export default ArchiveBlogPage;
